import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react/polaris";

import { RootState } from "../app/rootReducer";
import { removeNotification } from "./notificationConnector";

export const Notification = () => {
  const dispatch = useDispatch();
  const { notificationItems } = useSelector(
    (state: RootState) => state.notification
  );

  const flashBarItems: FlashbarProps.MessageDefinition[] = Object.entries(
    notificationItems
  ).map(([key, value]) => ({
    ...value,
    id: key,
    onDismiss: () => dispatch(removeNotification(parseInt(key, 10))),
  }));

  return (
    <Flashbar
      data-testid="notification-flashbar"
      items={flashBarItems}
      i18nStrings={{
        ariaLabel: "Notifications",
        errorIconAriaLabel: "Error",
        warningIconAriaLabel: "Warning",
        successIconAriaLabel: "Success",
        infoIconAriaLabel: "Info",
        inProgressIconAriaLabel: "In progress",
      }}
    />
  );
};
